
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/evaluation/[evaluationId]",
      function () {
        return require("private-next-pages/evaluation/[evaluationId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/evaluation/[evaluationId]"])
      });
    }
  